var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M240.8,75.3L240.8,75.3L111,206l0,0c-3.2,3.2-7.7,5.2-12.5,5.2c-4.9,0-9.3-2-12.5-5.2l0,0l-70.7-65l0,0c-3.2-3.2-5.2-7.7-5.2-12.6c0-9.9,7.9-17.8,17.7-17.8c4.9,0,9.3,2,12.5,5.2l0,0l58.1,52.3L215.7,50l0,0c3.2-3.2,7.7-5.2,12.5-5.2c9.8,0,17.7,8,17.7,17.8C246,67.6,244,72,240.8,75.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.90b82b6cf57df5fccbb865af43dea73f.svg";
export { ForwardRef as ReactComponent };